import {CENTRAL_QUARTER_PREFIX} from "../../constants/tokens";

/**
 * Проверяет, является ли токен центральным кварталом указанного игрока
 * @param {string} token - Тип токена
 * @param {string} playerColor - Цвет игрока
 * @returns {boolean}
 */
export const isPlayerCentralQuarter = (token, playerColor) => {
  return token === `${CENTRAL_QUARTER_PREFIX}${playerColor}`;
};